module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("T")]), _vm._v("he project would not have been possible but for the help and assistance of Martin Mace, John Grehan and my partner, Tricia Newsome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would like to thank Revd Jane Sinclair, Canon of Westminster and Rector of St Margaret’s Church, for kindly allowing me access to the altar of St Margaret’s Church to take photographs of the stained glass window commemorating the marriage of King Henry VIII to Katherine of Aragon. I also thank Elaura Lacey for her help and assistance. I also thank Robert Mitchell for his superb work and assistance with images. I am indebted to Helen Francis at Hever Castle, Bethan Clark at the Royal Mint Museum and the Department of Digital, Culture, Media and Sport, for their kindness and generosity in providing me with images for use within this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All images used in this publication are from the author’s collection unless stated otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For their support and assistance with images, I am grateful to the Dean and Chapter of Westminster Abbey and the Parliamentary Archives.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ec0aa0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/006_Acknowledgements.vue
// module id = 75
// module chunks = 0